const weatherCode = (weather_code) => {
  // console.log(weather_code);
  switch (parseInt(weather_code)) {
    case 100:
      weather_code = "1-0";
      break;
    case 101:
      weather_code = "1-1";
      break;
    case 102:
    case 103:
      weather_code = "1-2";
      break;
    case 104:
    case 105:
      weather_code = "1-3";
      break;
    case 106:
    case 107:
    case 160:
    case 170:
      weather_code = "1-4";
      break;
    case 110:
    case 111:
      weather_code = "1-5";
      break;
    case 112:
    case 113:
    case 114:
      weather_code = "1-6";
      break;
    case 115:
    case 116:
    case 117:
      weather_code = "1-7";
      break;
    case 118:
    case 181:
      weather_code = "1-8";
      break;
    case 200:
      weather_code = "2-0";
      break;
    case 201:
      weather_code = "2-1";
      break;
    case 202:
    case 203:
      weather_code = "2-2";
      break;
    case 204:
    case 205:
      weather_code = "2-3";
      break;
    case 206:
    case 207:
    case 260:
    case 270:
      weather_code = "2-4";
      break;
    case 210:
    case 211:
      weather_code = "2-5";
      break;
    case 212:
    case 213:
    case 214:
      weather_code = "2-6";
      break;
    case 215:
    case 216:
    case 217:
      weather_code = "2-7";
      break;
    case 218:
    case 281:
      weather_code = "2-8";
      break;
    case 300:
      weather_code = "3-0";
      break;
    case 301:
      weather_code = "3-1";
      break;
    case 302:
      weather_code = "3-2";
      break;
    case 303:
    case 304:
    case 309:
    case 340:
      weather_code = "3-3";
      break;
    case 308:
      weather_code = "3-4";
      break;
    case 311:
      weather_code = "3-5";
      break;
    case 313:
      weather_code = "3-6";
      break;
    case 314:
    case 315:
      weather_code = "3-7";
      break;
    case 316:
    case 361:
      weather_code = "3-8";
      break;
    case 317:
    case 371:
      weather_code = "3-9";
      break;
    case 400:
      weather_code = "4-0";
      break;
    case 401:
      weather_code = "4-1";
      break;
    case 402:
      weather_code = "4-2";
      break;
    case 403:
    case 409:
      weather_code = "4-3";
      break;
    case 406:
    case 407:
      weather_code = "4-4";
      break;
    case 411:
      weather_code = "4-5";
      break;
    case 413:
      weather_code = "4-6";
      break;
    case 414:
      weather_code = "4-7";
      break;
    default:
      weather_code = "4-7";
      break;
  }
  return weather_code;
}

export default weatherCode;